import {
  AddWorkerReviewSchema,
  AddWorkerReviewResponseSchema,
} from "@/schemas/review";
import type {
  AddWorkerReviewPayload,
  AddWorkerReviewResponse,
} from "@/schemas/review";

import { apiRequest } from "./apiUtils";

export async function addWorkerReview(
  payload: AddWorkerReviewPayload,
): Promise<AddWorkerReviewResponse> {
  AddWorkerReviewSchema.parse(payload);
  const url = `business/shift/add-worker-review`; // adjust endpoint if different
  const data = await apiRequest<unknown>(url, {
    method: "POST",
    body: JSON.stringify(payload),
  });
  return AddWorkerReviewResponseSchema.parse(data);
}
